import React from 'react';
import axios from 'axios';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

axios.defaults.withCredentials = true;

// CSRF: attach the double-submit token from the readable cookie on mutating requests
axios.interceptors.request.use((config) => {
  const m = document.cookie.match(/(?:^|; )csrf_token=([^;]+)/);
  if (m) config.headers['X-CSRF-Token'] = decodeURIComponent(m[1]);
  return config;
});
// Ensure a CSRF token cookie exists (covers sessions created before this change)
axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/auth/csrf`).catch(() => {});

import { Toaster } from "./components/ui/sonner";
import LandingPage from './pages/LandingPage';
import CreateProfile from './pages/CreateProfile';
import SignIn from './pages/SignIn';
import Verify from './pages/Verify';
import MagicLink from './pages/MagicLink';
import Claim from './pages/Claim';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import PublicProfile from './pages/PublicProfile';
import TeamPage from './pages/TeamPage';
import Dashboard from './pages/Dashboard';
import Directory from './pages/Directory';
import VerifyMessage from './pages/VerifyMessage';
import DemoCard from './pages/DemoCard';
import DemoBento from './pages/DemoBento';
import DemoHybrid from './pages/DemoHybrid';
import CreateGraphic from './pages/CreateGraphic';
import AdminAds from './pages/AdminAds';
import AdminPortal from './pages/AdminPortal';

function App() {
  return (
    <>
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/create-profile" element={<CreateProfile />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/verify" element={<Verify />} />
          <Route path="/magic" element={<MagicLink />} />
          <Route path="/claim/:username" element={<Claim />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/profile/:username" element={<PublicProfile />} />
          <Route path="/team/:slug" element={<TeamPage />} />
          <Route path="/preview/:username" element={<PublicProfile preview />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/directory" element={<Directory />} />
          <Route path="/verify/:token" element={<VerifyMessage />} />
          <Route path="/demo/card" element={<DemoCard />} />
          <Route path="/demo/bento" element={<DemoBento />} />
          <Route path="/demo/hybrid" element={<DemoHybrid />} />
          <Route path="/graphics" element={<CreateGraphic />} />
          <Route path="/admin" element={<AdminPortal />} />
          <Route path="/admin/ads" element={<AdminAds />} />
          {/* Vanity profile URL: offersz.co/username (must stay last so it never shadows real routes) */}
          <Route path="/:username" element={<PublicProfile />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
